import { useEffect, useState } from 'react';
import { defaultNavProps, scrollNavProps } from '../helper/constant';

const useScrollNavbar = (isScrollNavbar) => {
    const [navStyleProps, setNavStyleProps] = useState(
        isScrollNavbar ? scrollNavProps : defaultNavProps
    );

    const onScrollY = () => {
        window.scrollY > 60 ? setNavStyleProps(defaultNavProps) : setNavStyleProps(scrollNavProps);
    };

    useEffect(() => {
        if (isScrollNavbar) {
            window.addEventListener('scroll', onScrollY);
        }

        return () => window.removeEventListener('scroll', onScrollY);
    }, [isScrollNavbar]);

    return {
        navBgColor: navStyleProps.navBgColor,
        logo: navStyleProps.logo,
        linkColor: navStyleProps.linkColor,
        linkHoverIcon: navStyleProps.linkHoverIcon,
    };
};

export default useScrollNavbar;
